import ColorfulCard from "@/components/colorful/colorful-card/colorful-card";
import { getType } from "../util/functions";

const CardGrid = ({
	data,
	page,
	setPage,
	kind,
	activeGenre,
}: {
	data: any;
	page: any;
	setPage: any;
	kind?: string;
	activeGenre?: string;
}) => {
	const totalPages = data.totalPages;

	const generatePageNumbers = () => {
		const pages = [];
		for (let i = 1; i <= totalPages; i++) {
			if (i <= 4 || i === totalPages) {
				pages.push(i);
			} else if (i === 5) {
				pages.push("...");
			}
		}
		return pages;
	};

	return (
		<div className="px-6 w-full">
			<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-8 gap-[32px] place-items-center">
				{data?.content &&
					data?.content.length > 0 &&
					data?.content?.map((slide: any, index: number) => (
						<ColorfulCard
							key={index}
							slide={slide}
							kind={kind ?? getType(slide._class)?.kind ?? ""}
							activeGenre={activeGenre}
						/>
					))}
			</div>
			{totalPages > 1 && (
				<div className="flex justify-center mt-6 gap-2" dir="ltr">
					{generatePageNumbers().map((p, index) => (
						<button
							key={index}
							onClick={() => typeof p === "number" && setPage(p)}
							className={`px-4 py-2 mx-1 rounded-md ${
								page == p
									? "bg-custom-pink text-white"
									: "bg-gray-700 text-white"
							} ${p === "..." ? "cursor-default" : "cursor-pointer"}`}
							disabled={p === "..."}
						>
							{p}
						</button>
					))}
				</div>
			)}
		</div>
	);
};

export default CardGrid;
